import {createGlobalStyle} from 'styled-components';
import {bgBody, gray700, gray900} from './color';

export const GlobalStyles = createGlobalStyle`
  @media print {
    @page {
      size: letter;
      margin: 0;
    }
  }

  html {
    scroll-behavior: smooth;
  }
  
  body {
    background: ${bgBody};
    font-size: 16px;
  }

  h1 {
    margin: 0 0 2.5rem 0;
    font-weight: 500;
    color: ${gray900};
  }

  h2 {
    margin: 0 0 2rem 0;
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.75rem;
    color: ${gray900};
  }

  h3 {
    display: inline-block;
    margin: 0;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
    color: ${gray900};
  }

  h4 {
    margin: 0 0 .5rem 0;
    font-style: normal;
    font-weight: 500;
    font-size: .87rem;
    line-height: 1rem;
    color: ${gray900};

  }

  p {
    margin: 0;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-line;
    color: ${gray700};
  }

  em {
    font-style: normal;
    font-weight: 500;
    color: ${gray900};
  }
  
  .active-link {
    font-weight: bold;
    color: ${gray900};
  }
`;

